import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditEmailCredential } from '@app-store/slices/emailCredential/edit'

interface TaskAction extends Action {
    payload: IEditEmailCredential
}

const { onRequest, onSuccess, onFailure } = rootActions.emailCredential.edit
function* editSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/notifications/email-credentials/${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(rootActions.emailCredential.list.onEditItem(response.result))
            notification.success({
                message: 'Your credential is updated successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSagaTask)
}

export default editSaga
